import { BareActionContext } from 'vuex-typex'
import { FeedState } from '@/store/feed/state'
import { RootState } from '@/store'
import { IUser, UserMeta } from '@/model/user'
import userUtils from '@/store/user/actions/user-utils';
import userStore from '@/store/user/user-store';
import setFeedUser from '@/store/feed/actions/set-feed-user';

export default async function fetchFeedUser(context: BareActionContext<FeedState, RootState>, id: number) {
  if (userStore.users.has(id)) {
      console.log('fetchFeedUser: setting from user map: %j', userStore.users.get(id))
      setFeedUser(context, <IUser>userStore.users.get(id))
  } else {
    userUtils.userService.getById(id.toString()).then((user: IUser) => {
      console.log('fetchFeedUser: retrieved by id: %j', user)
      if (user) {
        user.meta = new UserMeta()
        userStore.users.set(id, user)
        setFeedUser(context, user)
        userStore.dispatchSetMeta(user)
      }
    })
  }

  return
}
